import { defineMessages } from "react-intl";

export const navigationMessages = defineMessages({
  homeLabel: {
    id: "nav-bar.wallet",
    defaultMessage: "Главная",
  },
  profileLabel: {
    id: "nav-bar.profile",
    defaultMessage: "Профиль",
  },
  transactionsLabel: {
    id: "nav-bar.transaction",
    defaultMessage: "История",
  },
});
